import { Component } from 'react';
import "../style.scss";

class Snow extends Component{
    render(){
        return(
            <div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              <div className="snow invisible md:visible"></div>
              
              
              </div>
        )
    }
}

export default Snow;